export interface IRegion {
  id?: number;
  regionName?: string;
}

export const defaultValue: Readonly<IRegion> = {};
